import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg';
import { RouterModule } from '@angular/router';
import { FLXDetailsComponent } from './views/details-view/details-view.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FLXListViewComponent } from './views/list-view/list-view.component';
import { MulService, ClaimService, JobService } from './services';
import { UIElementsModule } from '@flexus/ui-elements';
import { ThemeModule } from '@flexus/ux';
import { environment } from '../../../environments/environment';
import { UICompositesModule } from '@flexus/ui-composites';
import { ErrorHandlerModule } from '@flexus/error-handler';
import { ScreensModule } from '@flexus/screens';
import { ActivateStateGuard } from './guards/activate-state.guard';
import { DeactivateStateGuard } from './guards/deactivate-state.guard';
import { LoadMulManifestService } from './services/load-mul-manifest.service';
import { MulClaimCardComponent } from './components/mul-claim-card/mul-claim-card.component';
import { MulListClaimCardComponent } from './components/mul-list-claim-card/mul-list-claim-card.component';
import { MulJobCardComponent } from './components/mul-job-card/mul-job-card.component';
import { MulListJobCardComponent } from './components/mul-list-job-card/mul-list-job-card.component';
import { MulWorkflowShellComponent } from './base-components/mul-workflow-shell/mul-workflow-shell.component';
import { MulFlowComponent } from './base-components/mul-flow/mul-flow.component';
import { SearchBannerModule } from '../../app-shell-features';
import { MsalModule } from '@azure/msal-angular';
import { PublicClientApplication } from '@azure/msal-browser';
import { DynamicLoaderModule } from '@flexus/engine';
import { IdentityModule } from '@flexus/identity';


export function loadConfig(manifest: LoadMulManifestService) {
	return function () {
		return manifest.load();
	};
}
@NgModule({
	imports: [
		CommonModule,
		...environment.appShellFeatures,
		DynamicLoaderModule,
		ErrorHandlerModule,
		ScreensModule,
		InlineSVGModule,
		NgxPaginationModule,
		RouterModule,
		ThemeModule,
		UIElementsModule.forRoot({ environment: environment }),
		UICompositesModule,
		environment['azure']
			? MsalModule.forRoot(
					new PublicClientApplication({
						auth: {
							clientId: environment['azure']['clientId'],
							postLogoutRedirectUri: `${environment.base_url}auth/login`
						}
					}),
					null,
					null
			  )
			: CommonModule,
		IdentityModule.forRoot({
			after_login_url: '/workflow',
			after_logout_url: '/auth/login',
			send_reset_link_endpoint: `${environment.api_url}v1/forgot_password/check-email`,
			login_endpoint: `${environment.api_url}v2/auth/login/`,
			no_auth_urls: ['/cons']
		}),
		SearchBannerModule
	],
	declarations: [
		MulClaimCardComponent,
		MulListClaimCardComponent,
		MulJobCardComponent,
		MulListJobCardComponent,
		FLXDetailsComponent,
		FLXListViewComponent,
		MulWorkflowShellComponent,
		MulFlowComponent
	],
	exports: [
		...environment.appShellFeatures,
		MulClaimCardComponent,
		MulJobCardComponent,
		MulListClaimCardComponent,
		MulListJobCardComponent,
		FLXDetailsComponent,
		FLXListViewComponent
	],
	providers: [
		ActivateStateGuard,
		DeactivateStateGuard,
		MulService,
		ClaimService,
		JobService,
		{
			provide: APP_INITIALIZER,
			useFactory: loadConfig,
			deps: [LoadMulManifestService],
			multi: true
		}
	]
})
export class MulManifestModule {}
